import { TableCell, TableRow } from '@ovComponents/2-component/table/table';
import { Box, Skeleton } from 'hephaestus/web';
export type PortfoliosTableSkeletonRowProps = {
  colSpan: number;
  py?: number;
};

export const PortfoliosTableSkeletonRow = ({
  colSpan,
  py = 2,
}: PortfoliosTableSkeletonRowProps) => (
  <TableRow>
    <TableCell colSpan={colSpan}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: py,
        }}
      >
        <Skeleton
          variant='rectangular'
          width='80%'
          height={16}
          sx={{ mx: 'auto' }}
        />
      </Box>
    </TableCell>
  </TableRow>
);
